<template>
  <div>
    <filters></filters>
    <product-list></product-list>
  </div>
</template>

<script>
import filters from '@/components/Filters'
import productList from '@/components/ProductList'

export default {
  props: {
    lang: {
      type: String,
      required: true
    }
  },
  name: 'Search',
  components: {
    filters,
    productList
  },
  data: function () {
    return {
      queryString: ''
    }
  },
  created: function () {
    this.$store.dispatch('setLang', this.lang)
    this.$store.dispatch('mapFilters', this.$store.getters.filters)
    this.$store.dispatch('search')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Search.vue